export default v => (!v || v === "0001-01-01T00:00:00Z" ? null : new Date(v));
